import AddPromoPage from './AddPromoPage';

export default AddPromoPage;
